import { render, staticRenderFns } from "./subscription-plan.component.vue?vue&type=template&id=192298a7&scoped=true"
import script from "./subscription-plan.component.ts?vue&type=script&lang=ts&external"
export * from "./subscription-plan.component.ts?vue&type=script&lang=ts&external"
import style0 from "./subscription-plan.component.vue?vue&type=style&index=0&id=192298a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192298a7",
  null
  
)

export default component.exports